const testResults: {
  video: string;
  answer: string;
}[] = [
  {
    video: "metv-ang1-1.m4v",
    answer: "anger",
  },
  {
    video: "metv-ang1-4.m4v",
    answer: "anger",
  },
  {
    video: "metv-ang1-6.m4v",
    answer: "anger",
  },
  {
    video: "metv-ang1-7.m4v",
    answer: "anger",
  },
  {
    video: "metv-con1-1.m4v",
    answer: "contempt",
  },
  {
    video: "metv-con1-2.m4v",
    answer: "contempt",
  },
  {
    video: "metv-dis1-1.m4v",
    answer: "disgust",
  },
  {
    video: "metv-dis1-2.m4v",
    answer: "disgust",
  },
  {
    video: "metv-fea1-1.m4v",
    answer: "fear",
  },
  {
    video: "metv-fea1-2.m4v",
    answer: "fear",
  },
  {
    video: "metv-fea1-4.m4v",
    answer: "fear",
  },
  {
    video: "metv-hap1-1.m4v",
    answer: "happiness",
  },
  {
    video: "metv-neu1-4.m4v",
    answer: "neutral",
  },
  {
    video: "metv-sad1-1.m4v",
    answer: "sadness",
  },
  {
    video: "metv-sad1-2.m4v",
    answer: "sadness",
  },
  {
    video: "metv-sad1-3.m4v",
    answer: "sadness",
  },
  {
    video: "metv-sad1-5.m4v",
    answer: "sadness",
  },
  {
    video: "metv-sur1-1.m4v",
    answer: "surprise",
  },
  {
    video: "metv-sur1-3.m4v",
    answer: "surprise",
  },
  {
    video: "metv-sur1-6.m4v",
    answer: "surprise",
  },
];

export default testResults;
